import {TechnicalSupportService} from '@services/TechnicalSupport/TechnicalSupportService';
import NewTable from '@ui/NewTable/NewTable';
import {useCallback, useEffect, useMemo} from 'react';
import {useTableData} from 'utils/hooks/useTableData';
import {useTablePage} from 'utils/hooks/useTablePage';
import {formateTechnicalSupportTableColumns} from './utils';

type TechnicalSupportTableProps = {
    forceRefetch: number;
    setSelectedItemId: (data: string) => void;
};

const service = TechnicalSupportService;

export const TechnicalSupportTable = ({
    setSelectedItemId,
    forceRefetch,
}: TechnicalSupportTableProps) => {
    const [pageStore, updatePageData] = useTableData({
        getData: service.getTableData,
        needFormatting: true,
    });

    const schemaGetter = useCallback(() => service.getTableSchema(), []);

    const {
        page,
        rowsPerPage,
        sortConfig,
        schema,
        columns,
        tableConfig,
        rows,
        ref,
        handleUpdate,
        setPage,
        setRowsPerPage,
        setSortConfig,
        filterConfig,
        setFilterConfig,
    } = useTablePage({
        pageId: 'TechnicalSupportTable',
        pageStore,
        service,
        updatePageData,
        schemaGetter,
    });

    useEffect(() => {
        if (!!schema) {
            handleUpdate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, schema, sortConfig, rowsPerPage, filterConfig, forceRefetch]);

    const formattedColumns = formateTechnicalSupportTableColumns({
        columns,
        setSelectedItemId,
    });

    const filterRequestData = useMemo(() => {
        const filterData: Record<string, any> = {
            baseEntityId: null,
        };

        if (schema?.additionalProperties) {
            filterData.additionalProperties = schema.additionalProperties;
        }
        return filterData;
    }, [schema?.additionalProperties]);

    if (!schema?.properties) {
        return null;
    }
    return (
        <div
            ref={ref}
            className='table-container'
        >
            <NewTable
                tableName='accounts'
                columns={formattedColumns}
                tableConfig={tableConfig}
                rows={rows}
                filterConfig={filterConfig}
                setFilterConfig={setFilterConfig}
                onUpdate={handleUpdate}
                sortConfig={sortConfig}
                setSortConfig={setSortConfig}
                totalElements={pageStore?.total || 0}
                page={page}
                rowsPerPage={rowsPerPage}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                filterRequestData={filterRequestData}
            />
        </div>
    );
};
